import webcall from '@/scripts/webcall';
import analytic from '@/scripts/libs/analytic';
import { EmailLoginOptions } from './strategy';
import { makeAuthTrackerPayload } from './helpers';

export const emailLoginStrategy = (params: EmailLoginOptions): Promise<void> => {
  analytic.send({
    category: 'sign-in',
    action: 'email-address',
  });
  window.fbq?.('track', 'CompleteRegistration');

  const authTrackerParams = makeAuthTrackerPayload(params.authTracker);

  return webcall.user.login.email({
    params: {
      ...authTrackerParams,
      email: params.email,
      callback: params.callback,
      origin: params.origin,
    },
  });
};
